import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveProducts, receiveTickets } from '@ttstr/actions';
import { Container, LoadingSpinner, Masonry, useIntl, Maki2020 } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';
import { Article } from '@ttstr/api';

// wird nicht mehr gebraucht: Header soll ganz raus
// import MerchstandImages from './assets/images/MerchstandImages';

type Props = {
  /**
   * productFilter can be used if you want a Route to a dedicated page for special merch/products.
   *
   * Example:
   * You want a page only with merch that has the tag id 1234.
   * The function for productFilter would then be
   *  p => p.tag_ids.includes(1234)
   *
   * Then create a route in App.tsx with
   * <Route exact path="/specialmerch" render={()=> <ProductListing productFilter={p => p.tag_ids.includes(1234)} />} />
   */
  productFilter?: (p: Article) => any;
};

const MerchStand: React.FC<Props> = ({ productFilter = (p) => p }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { products, loadingProducts, tickets, loadingTickets } = useShallowEqualSelector(mapStateToProps);
  const { receiveProducts, receiveTickets } = useActions(mapDispatchToProps);
  const { language } = useIntl();
  const [specialHeader, setSpecialHeader] = React.useState<string>('normal');

  React.useEffect(() => {
    receiveProducts();
    receiveTickets();
  }, [language]);

  // wird nicht mehr gebraucht: Header soll ganz raus
  // React.useEffect(() => {
  //   if (window.location.href.endsWith('merchstand')) {
  //     const number = Math.floor(Math.random() * 4 + 1);
  //     setSpecialHeader('var' + number);
  //   }
  // }, []);

  return (
    <article className="mb-5">
      <div className="headerimage-tour  mb-5">
        <div className="headerimage-content text-right p-5">
          <h1>
            {'MERCH! MERCH! MERCH!'}
            <small className="d-block mb-3">Willkommen an unserem digitalen Merchstand!</small>
          </h1>
        </div>
      </div>

      <Container className="list-page-merchandise">
        <Helmet>
          <title>{t(`PRODUCTS.TITLE`)}</title>
          <body className="merch-listing-page inverse-navbar" />
        </Helmet>

        {/* @ts-ignore */}
        {/* <img src={MerchstandImages[specialHeader]} alt="Preorder" className="img-fluid mb-5" /> */}
        {/* <h1 className="text-center mb-0 mt-5">{t(`PRODUCTS.TITLE`)}</h1> */}

        {loadingProducts || loadingTickets ? ( // if loading
          <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
        ) : products.length === 0 ? ( // if no products
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show products
          <Masonry
            id="product-listing"
            products={products.filter(productFilter)}
            filters="off"
            showSubtitle
            type={Maki2020}
            columnClassName=""
            itemClassName=""
            itemImageClassName=""
          />
        )}
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { products } = state.Products;
  const loadingProducts = state.Products.loading;
  const { tickets } = state.Tickets;
  const loadingTickets = state.Tickets.loading;
  return {
    products,
    loadingProducts,
    tickets,
    loadingTickets,
  };
};

const mapDispatchToProps = {
  receiveProducts,
  receiveTickets,
};

export default React.memo(MerchStand);
